import type { SVGProps } from "react";
import * as React from "react";
const SvgDustLogoSquareLayer2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#3B82F6"
      fillRule="evenodd"
      d="M12 36a6 6 0 0 1 0-12h36v12H12Z"
      clipRule="evenodd"
    />
    <path fill="#418B5C" d="M12 0H0v24h12V0Z" />
    <path fill="#E14322" d="M48 0H24v12h24V0Z" />
  </svg>
);
export default SvgDustLogoSquareLayer2;
